import * as React from "react";
import { CompetitionBreedPanel } from "./CompetitionBreedPanel";
import { CompetitionBreedGroupPanel } from "./CompetitionBreedGroupPanel";

export interface ICompetitionRequestBreedsPanelProps {
  competitionRequestId: number;
  editMode: boolean;
}

export const CompetitionRequestBreedsPanel: React.FunctionComponent<ICompetitionRequestBreedsPanelProps> = ({
  competitionRequestId,
  editMode,
}) => {
  return (
    <>
      <CompetitionBreedGroupPanel />{" "}
      <CompetitionBreedPanel competitionRequestId={competitionRequestId} editMode={editMode} />
    </>
  );
};
